import { render, staticRenderFns } from "./WaitListIcon.vue?vue&type=template&id=2699ebab&scoped=true"
import script from "./WaitListIcon.vue?vue&type=script&lang=js"
export * from "./WaitListIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2699ebab",
  null
  
)

export default component.exports